import React from 'react';
import Footer from './Footer';
import ServiceSpotlight from './ServiceSpotlight';

function EInvoicingPage() {
  return (
    <main className="sections-container">
      <section id="einvoicing">
        <ServiceSpotlight />
      </section>
      <Footer />
    </main>
  );
}

export default EInvoicingPage;
